<template>
  <div class="user-management-my-invite">
    <div class="invite__wrapper">
      <div class="invite__banner">
        <div class="invite__title">
          <h3 class="title__item">
            <span>{{ $t("personal.myInvite.title1") }}</span>
            <span>{{ $t("personal.myInvite.title2") }}</span>
          </h3>
          <h3 class="title__item-text">
            {{ $t("personal.myInvite.title3") }}
            <span>{{ $t("personal.myInvite.title4") }}</span>
            {{ $t("personal.myInvite.title5") }}
          </h3>
        </div>
        <div class="invite__bg">
          <img
            src="https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210726061442681.png"
            alt=""
          />
        </div>
      </div>
      <div class="invite__my">
        <div class="left">
          <h4 class="invite__my-title">{{ $t("personal.myInvite.my") }}</h4>
          <div class="num__show">
            <div class="show__item">
              <!-- <i class="show__triangle">+0</i> -->
              <p class="show__num">{{ invitationUserCount }}</p>
              <p class="show__text">
                <img src="../../assets/images/1/yaoqing.png" alt="" />
                <span>{{ $t("personal.myInvite.number") }}</span>
              </p>
            </div>
            <div class="show__item">
              <!-- <i class="show__triangle">+0.00</i> -->
              <p class="show__num">{{ totalRewardAmount }}</p>
              <p class="show__text">
                <img src="../../assets/images/1/shouru.png" alt="" />
                <span>{{ $t("personal.myInvite.reward", {coin: rewardCoinSymbol}) }}</span>
              </p>
            </div>
            <div class="show__item">
              <p class="show__num">{{ miningGrantAmountByInvitation }}</p>
              <p class="show__text">
                <img src="../../assets/images/1/reward.png" alt="" />
                <span>{{ $t("personal.myInvite.profits", {coin: miningGrantSymbol}) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="code__item">
            <p class="code__text">{{ $t("personal.myInvite.code") }}</p>
            <p class="code__copy">
              {{ inviteCode }}
              <img
                @click="copyClick('code')"
                src="../../assets/images/1/fuzhi.png"
                alt=""
              />
            </p>
          </div>
          <div class="code__item">
            <p class="code__text">{{ $t("personal.myInvite.link") }}</p>
            <p class="code__copy">
              {{ inviteUrl }}
              <img
                @click="copyClick('link')"
                src="../../assets/images/1/fuzhi.png"
                alt=""
              />
            </p>
          </div>
        </div>
      </div>
      <div class="invite__list">
        <h4 class="invite__my-title">{{ $t("personal.myInvite.details") }}</h4>
        <div class="tab__container">
          <div class="tab__content">
              <!-- :class="tableType === 'list' ? 'active' : ''" -->
            <!-- <span
              class="active"
              @click="onTabChange('list')"
            >
              {{ $t("personal.myInvite.list") }}
            </span> -->
              <!-- :class="tableType === 'profitList' ? 'active' : ''" -->
            <!-- <span
              @click="onTabChange('profitList')"
            >
              {{ $t("personal.myInvite.profitsList") }}
            </span> -->
          </div>
          <div class="search__container" v-if="tableType === 'list'">
            <c-date-picker v-model="startTime"></c-date-picker>
            <span class="gang">—</span>
            <c-date-picker v-model="endTime"></c-date-picker>
            <c-new-select
              :selectList="coinList"
              v-model="selectCoin"
              style="margin-left: 10px;"
            >
              <img class="icon" src="@/assets/images/1/bizhong.png" alt=""  slot="icon">
            </c-new-select>
            <button @click="onSearch">{{ $t("common.search") }}</button>
          </div>
          <div class="table__container">
            <c-table
              :imgMap="imgMap"
              :colorMap="colorMap"
              :columns="columns"
              :dataList="dataList"
              :cellHeight="50"
              :loading="tableLoading"
            />
          </div>
          <c-pagination
            v-if="pagination.count / pagination.pageSize > 1"
            :total="pagination.count"
            classes="invite-page"
            :current-page="pagination.page"
            :display="pagination.pageSize"
            @pagechange="pagechange"
          >
          </c-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/personal/myInvite/myInvite';
import 'BlockChain-ui-privatization/PC/common-mixin/personal/myInvite/myInvite.styl';

export default {
  mixins: [mixin],
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus">
.user-management-my-invite {
  background-color: #141C3F;
  padding-bottom: 120px;
}

.invite__wrapper {
  width: 1080px;
  margin: auto;
}

// banner
.invite__banner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.title__item span{
  font-size: 44px;
}
.en_US .title__item span{
  font-size: 38px;
}
.title__item span:first-of-type {
  margin-right 40px;
}
.en_US .title__item span:first-of-type {
  margin-right 0px;
}

.title__item-text {
  margin-top: 20px;
  font-size: 38px;
}
.en_US .title__item-text {
  margin-top: 20px;
  font-size: 30px;
  opacity 0.85;
}

.title__item-text span {
  color: #FFCB00;
}

.invite__bg {
  padding-top: 10px;
  width: 288px;
}

.invite__bg img {
  width: 100%;
}

.invite__title {
  padding: 44px 0 38px;
  // text-align: center;
  font-family: PingFangSC-Medium;
  // font-size: 34px;
  color: #FFFFFF;
  letter-spacing: 1.51px;
  font-weight: 500;
  min-width: 564px;
}

// my invite
.invite__my {
  display: flex;
  justify-content: space-between;
}

.left {
  width: 586px;
  // height 130px;
  padding: 22px 23px 24px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
}

.invite__my-title {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.07px;
  font-weight: 400;
  margin-bottom: 20px;
}

.num__show {
  display: flex;
  // justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}

.show__item {
  width 33%;
}

.show__triangle {
  width: fit-content;
  display: block;
  height: 20px;
  padding: 0 6px;
  line-height: 18px;
  background-image: url('../../assets/images/1/square.png');
  background-repeat: no-repeat;
  font-size: 12px;
  background-size: 100% 100%;
}

.show__num {
  font-size: 20px;
  margin: 5px 0 10px;
}

.show__text {
  display: flex;
  align-items: center;
}

.show__text img {
  width: 16px;
  display: block;
  margin-right: 6px;
}

.show__text span {
  font-size: 12px;
  color: #737373;
}

.right {
  width: 478px;
  // height 130px;
  padding: 20px 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.code__item {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}

.code__item:first-of-type {
  margin-bottom: 10px;
}

.code__text {
  width: 116px;
}
.en_US .code__text {
  width: 140px;
}

.code__copy {
  // display: flex;
  // align-items: center;
  flex: 1;
  word-break: break-all;
}

.code__copy img {
  position relative;
  top: 3px;
}

.code__copy img {
  width: 12px;
  margin-left: 5px;
  cursor: pointer;
}

// list
.invite__list {
  width: 100%;
  background-color: #fff;
  margin-top: 12px;
  border-radius: 4px;
  padding: 22px 23px 30px;
  box-sizing: border-box;
}

.search__container {
  display: flex;
  padding: 0 20px;
  box-sizing: border-box;
  align-items center;
  margin-bottom 20px;
}
.search__container .gang {
  padding: 0 10px;
  color: rgba(51,51,51,.3);
}

.search__container button {
  display: flex;
  height: 26px;
  padding: 0 18px;
  line-height: 26px;
  background-color: #35429E;
  border-radius: 20px;
  color: #fff;
  margin-left: 30px;
}

.dataBg {
  background: #0d1331 !important;
}

.invite__list .table__container .common-table {
  background-color: #fff !important;
}

.invite__list .table__container .table-head,
.invite__list .table__container .table-body tbody tr {
  border-color: #EBEBEB!important;
}
.invite__list .invite-page .a-3-bd {
  border-top-color transparent!important;
}

.tab__container {
  margin-top: 18px;
  border: 1px solid #EFF1FD;
}

.table__container {
  padding: 0 20px;
  box-sizing: border-box;
}

.tab__content {
  height: 40px;
  line-height: 40px;
  background-color: rgba(154, 170, 240, 0.16);
  margin-bottom 20px;
}

.tab__content span {
  padding: 0 20px;
  color: #333333;
  display: inline-block;
  cursor: pointer;
  margin-right: 20px;
}

.tab__content span.active {
  background-color: #fff;
  color: #35429E;
  position: relative;
}

.tab__content span.active:after {
  content: '';
  width: 0px;
  height: 0px;
  border-top: 40px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 40px solid #fff;
  border-left: 20px solid rgba(0, 0, 0, 0);
  display: inline-block;
  -webkit-transform: translate(-54px, 10px);
  /* transform: translate(-54px, 10px); */
  position: absolute;
  top: -50px;
  right: -65px;
}

.tab__content span:last-of-type.active:after {
  right: unset;
  transform: rotateX(180deg);
  top: 0;
  left: -20px;
}
.invite-page.a-5-bg {
  background-color #fff!important;
}


.ru_RU .num__show{
  padding:0 5px;
}
.ru_RU .right{
  padding:20px;
}
</style>
